import { component, install } from 'riot'
import './media/favicon.png'

import store from './store/store.js'

import App from './app.riot'

install(function(component) {
    component.states$ = store.states$
    component.actions = store.actions
    return component
})

if (DEVELOPMENT || STAGE) {
    window.state = store.states$
}

component(App)(document.getElementById('root'))
